import {
  collection,
  query,
  where,
  orderBy,
  limit,	
  getDocs,
  getDoc,
  setDoc,
  doc,
  Timestamp
} from "firebase/firestore";
import { db } from "../firebase";

const SYSTEM_START_DATE = "2026-01-10";
/* ================= IST DATE UTIL ================= */

function getISTDateString(date = new Date()) {
  

  const istOffset = 5.5 * 60 * 60 * 1000;
  const ist = new Date(date.getTime() + istOffset);
  return ist.toISOString().slice(0, 10); // YYYY-MM-DD
}

/* ================= PARTY LIST ================= */

export async function fetchParties() {
  const q = query(
    collection(db, "partyMaster"),
    where("partytype", "==", "hawker")
  );

  const snap = await getDocs(q);
  return snap.docs.map(d => ({
    partyId: d.data().partyId,
    name: d.data().name
  }));
}

/* ================= PREVIOUS DAY LEDGER ================= */

export async function fetchPreviousDayLedger(partyId, todayIST) {
  // ✅ Day-1 system start: do NOT block
  
  
 if (todayIST <= SYSTEM_START_DATE) {
  return { closingBalance: 0 };
}


  const prev = new Date(todayIST);
  prev.setDate(prev.getDate() - 1);
 


const q = query(
  collection(db, "salesman_ledger"),
  
  
  
  
  where("partyId", "==", partyId),
  
  
  
  where("dateIST", "<", todayIST),
  orderBy("dateIST", "desc"),
  limit(1)
);
const snap = await getDocs(q);
return snap.empty ? null : snap.docs[0].data();
  
  
  
  
    //CHECK THIS LINE FOR ERROR//
}

/* ================= TODAY ORDER AMOUNT ================= */

export async function fetchTodayOrderAmount(partyId, todayIST) {
  const q = query(
    collection(db, "orders"),
    where("partyId", "==", partyId),
    where("approvedDateOnly", "==", todayIST),
    where("status", "==", "APPROVED")
  );

  const snap = await getDocs(q);

  let total = 0;
  snap.forEach(d => {
    total += Number(d.data().totalAmount || 0);
  });

  return total;
}

/* ================= SAVE LEDGER ================= */

export async function saveDayClose({
  partyId,
  openingBalance,
  orderAmount,
  denominations,
  onlineCollected = 0
}) {
  const dateIST = getISTDateString();





const cashCollected =
  (denominations[500] || 0) * 500 +
  (denominations[200] || 0) * 200 +
  (denominations[100] || 0) * 100 +
  (denominations[50] || 0) * 50 +
  (denominations[20] || 0) * 20 +
  (denominations[10] || 0) * 10 +
  (denominations[5] || 0) * 5 +
  (denominations[1] || 0) * 1;


  const closingBalance =
    Number(openingBalance) +
    Number(orderAmount) -
    Number(onlineCollected) -
    Number(cashCollected);


const ref = doc(db, "salesman_ledger", `${partyId}_${dateIST}`);

const existingSnap = await getDoc(ref);

// ===========================
// CASE 1 — NO ENTRY
// ===========================
if (!existingSnap.exists()) {

  await setDoc(ref, {

    partyId,
    dateIST,

    openingBalance,
    orderAmount,
    onlineCollected,

    denominations,
    cashCollected,
    closingBalance,

    status: "PENDING",
    dayClose: false,

    createdAt: Timestamp.now()
  });

  return;
}

// ===========================
// CASE 2 — ENTRY EXISTS
// ===========================

const existingData = existingSnap.data();

// ❌ APPROVED — BLOCK
if (existingData.status === "APPROVED") {

  alert("Already approved for today. Entry locked.");
  return;
}

// ✅ PENDING or REJECTED — OVERWRITE
await setDoc(ref, {

  partyId,
  dateIST,

  openingBalance,
  orderAmount,
  onlineCollected,

  denominations,
  cashCollected,
  closingBalance,

  status: "PENDING",        // FORCE RESET
  dayClose: false,

  rejectionRemark: "",      // CLEAR OLD REJECTION
  updatedAt: Timestamp.now()

});
  
  
  
  
  
  
}
